var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('div',{staticClass:"tooltipClass",style:(("max-width:" + _vm.oWidth + "px !important"))},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({style:(("color:" + _vm.diableColor))},on),[_vm._v(_vm._s(_vm.content))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.content))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }